import { dataHooks } from '@wix/data-hooks';

export const attachFileDataHooks = dataHooks<{
  tooltipArticleLink;
  tooltip;
  fileUpload;
  button;
  loader;
}>('AttachFile');
